import React from "react";

const ContactSvgHeader = ({
  color = "#E11B22",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1500_15539)">
        <path
          d="M1.17551 14.6693H9.27437C10.3282 16.1135 12.3578 16.4257 13.802 15.3914C15.2461 14.3376 15.5583 12.308 14.524 10.8639C14.1677 10.3727 13.6806 9.99156 13.1182 9.76383C12.5558 9.5361 11.9407 9.47096 11.343 9.57584C10.6405 8.48297 9.56713 7.68286 8.31814 7.29254C10.2111 6.31675 10.9527 3.97494 9.95745 2.08192C8.96218 0.188904 6.63984 -0.552647 4.74682 0.442621C2.85381 1.43789 2.13178 3.76022 3.10752 5.6532C3.47832 6.35575 4.04427 6.92171 4.74682 7.2925C2.42449 8.01457 0.84375 10.1613 0.84375 12.5812V14.318C0.84375 14.5132 0.999868 14.6693 1.17551 14.6693ZM11.2649 10.2979C12.631 9.94659 14.0166 10.7857 14.3679 12.1518C14.7192 13.518 13.88 14.9035 12.5139 15.2548C10.9137 15.6451 9.35245 14.4157 9.35245 12.7568C9.35245 11.5859 10.133 10.5711 11.2649 10.2979ZM3.36124 3.89682C3.36124 2.14044 4.76634 0.715818 6.52272 0.715818C8.2791 0.715818 9.70373 2.12092 9.70373 3.8773C9.70373 5.63368 8.29862 7.0583 6.52272 7.0583C4.78586 7.0583 3.36124 5.63372 3.36124 3.89682ZM1.52678 12.5812C1.52678 9.90755 3.693 7.74134 6.38613 7.72182H6.71788C8.2791 7.72182 9.76229 8.48293 10.6795 9.77091C9.50861 10.2588 8.68894 11.4297 8.68894 12.7568C8.68894 13.1471 8.76702 13.5764 8.92314 13.9862H1.52678V12.5812Z"
          fill={color}
        />
        <path
          d="M10.5819 13.1081H11.5577V14.0839C11.5577 14.279 11.7138 14.4352 11.9089 14.4352C12.1041 14.4352 12.2602 14.279 12.2602 14.0839V13.1081H13.236C13.4312 13.1081 13.5873 12.952 13.5873 12.7568C13.5873 12.5617 13.4312 12.4055 13.236 12.4055H12.2602V11.4493C12.2602 11.2541 12.1041 11.098 11.9089 11.098C11.7138 11.098 11.5577 11.2541 11.5577 11.4493V12.4055H10.5819C10.3867 12.4055 10.2306 12.5617 10.2306 12.7568C10.2306 12.952 10.3867 13.1081 10.5819 13.1081Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1500_15539">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactSvgHeader;
